export type GreetingStatus = "enviado" | "leido_por_locutor" | "al_aire" | "archivado";
export type SongRequestStatus = "pendiente" | "aceptada" | "atendida" | "reproducida" | "rechazada" | "cancelada" | "expirada";

export interface ListenerGreeting {
  id: number;
  radioName: string;
  radioImage: string;
  radioFrequency: string;
  content: string;
  sentAt: string;
  status: GreetingStatus;
  readAt?: string;
  airedAt?: string;
  locutorResponse?: string;
  respondedAt?: string;
}

export interface ListenerSongRequest {
  id: number;
  songName?: string;
  artistName?: string;
  radioName: string;
  radioImage: string;
  radioFrequency: string;
  greeting?: string;
  dedication?: string;
  requestedAt: string;
  status: SongRequestStatus;
  acceptedAt?: string;
  attendedAt?: string;
  playedAt?: string;
  rejectedAt?: string;
  rejectionReason?: string;
  operatorResponse?: string;
}

export const listenerGreetings: ListenerGreeting[] = [
  {
    id: 1,
    radioName: "La Mexicana FM",
    radioImage: "https://readdy.ai/api/search-image?query=Mexican%20regional%20radio%20station%20logo%20with%20guitar%20and%20sombrero%20elements%2C%20circular%20design%20warm%20orange%20and%20green%20colors%2C%20clean%20modern%20broadcast%20style&width=200&height=200&seq=lg-radio-mexicana&orientation=squarish",
    radioFrequency: "98.7 FM",
    content: "Un saludo enorme para toda la gente de San José que nos escucha desde temprano. ¡Arriba el barrio El Carmen! Y un abrazo especial para mi esposa Andrea.",
    sentAt: "2026-07-15T14:22:00",
    status: "enviado",
  },
  {
    id: 2,
    radioName: "Radio Nueva Actitud",
    radioImage: "https://readdy.ai/api/search-image?query=Modern%20minimalist%20radio%20station%20logo%20design%20with%20musical%20notes%20and%20frequency%20waves%2C%20clean%20circular%20emblem%20style%2C%20warm%20golden%20and%20white%20color%20palette&width=200&height=200&seq=lg-radio-nueva&orientation=squarish",
    radioFrequency: "102.5 FM",
    content: "Saludos para todo el equipo, son los mejores. Especialmente para Natalia que nos alegra las mañanas y a Diego que siempre me hace reír con sus comentarios.",
    sentAt: "2026-07-15T14:18:00",
    status: "leido_por_locutor",
    readAt: "2026-07-15T14:30:00",
  },
  {
    id: 3,
    radioName: "Rock Total Radio",
    radioImage: "https://readdy.ai/api/search-image?query=Rock%20radio%20station%20logo%20with%20electric%20guitar%20and%20lightning%20bolt%2C%20circular%20design%20black%20and%20red%20color%20scheme%2C%20modern%20rock%20broadcast%20emblem%2C%20energetic%20bold%20style&width=200&height=200&seq=lg-radio-rock&orientation=squarish",
    radioFrequency: "95.3 FM",
    content: "Desde Alajuela mandando un abrazo a todos los escuchas de la noche. Ustedes hacen que manejar de vuelta a casa sea mucho más llevadero. ¡Temazos los de hoy!",
    sentAt: "2026-07-15T13:15:00",
    status: "al_aire",
    readAt: "2026-07-15T13:20:00",
    airedAt: "2026-07-15T13:28:00",
    locutorResponse: "¡Gracias Tomás! Un abrazo enorme para vos y todos los que van de vuelta a casa. ¡Aguante el rock!",
    respondedAt: "2026-07-15T13:30:00",
  },
  {
    id: 4,
    radioName: "Radio Fe y Esperanza",
    radioImage: "https://readdy.ai/api/search-image?query=Christian%20radio%20station%20logo%20with%20dove%20symbol%2C%20circular%20minimalist%20design%2C%20soft%20warm%20colors%20white%20and%20gentle%20golden%20tones%2C%20clean%20modern%20broadcast%20emblem&width=200&height=200&seq=lg-radio-fe&orientation=squarish",
    radioFrequency: "88.1 FM",
    content: "Bendiciones para todo el equipo de Radio Fe y Esperanza. Hoy celebro 10 años de escucharlos todas las mañanas. Son mi compañía fiel camino al trabajo.",
    sentAt: "2026-07-15T11:10:00",
    status: "al_aire",
    readAt: "2026-07-15T11:15:00",
    airedAt: "2026-07-15T11:22:00",
    locutorResponse: "¡Amén Ana Patricia! 10 años de bendiciones mutuas. Gracias por tu fidelidad y por compartir tus mañanas con nosotros.",
    respondedAt: "2026-07-15T11:25:00",
  },
  {
    id: 5,
    radioName: "Banda Radio MX",
    radioImage: "https://readdy.ai/api/search-image?query=Mexican%20banda%20music%20radio%20station%20logo%20with%20trumpet%20and%20accordion%2C%20circular%20design%20red%20white%20and%20green%20colors%2C%20festive%20broadcast%20emblem%2C%20traditional%20Mexican%20vibe&width=200&height=200&seq=lg-radio-banda&orientation=squarish",
    radioFrequency: "107.9 FM",
    content: "Buen día a todos! Hoy amanecí con una energía increíble y quería compartirla con todo el equipo. Que tengan un día hermoso lleno de buena música y vibras positivas.",
    sentAt: "2026-07-15T09:55:00",
    status: "archivado",
    readAt: "2026-07-15T10:05:00",
  },
  {
    id: 6,
    radioName: "La Kalle 99.9",
    radioImage: "https://readdy.ai/api/search-image?query=Pop%20music%20radio%20station%20logo%20with%20headphones%20and%20music%20equalizer%20bars%2C%20circular%20design%20vibrant%20pink%20and%20coral%20colors%2C%20modern%20youthful%20broadcast%20emblem%2C%20energetic%20style&width=200&height=200&seq=lg-radio-kalle&orientation=squarish",
    radioFrequency: "99.9 FM",
    content: "Buen díaaaas! Saludos al equipo de Tardes de Pop, me acompañan en el gym todas las tardes y hacen mi rutina mucho más divertida. ¡Son lo máximo!",
    sentAt: "2026-07-15T08:40:00",
    status: "archivado",
    readAt: "2026-07-15T08:50:00",
  },
  {
    id: 7,
    radioName: "Deportes Total Radio",
    radioImage: "https://readdy.ai/api/search-image?query=Sports%20radio%20station%20logo%20with%20soccer%20ball%20and%20trophy%20icon%2C%20circular%20design%20dark%20blue%20and%20gold%20color%20scheme%2C%20dynamic%20broadcast%20emblem%2C%20energetic%20sports%20feel&width=200&height=200&seq=lg-radio-deportes&orientation=squarish",
    radioFrequency: "101.1 FM",
    content: "Saludos desde Alajuela para todos los radioescuchas. Hoy cumplo 25 años de casado y quiero dedicarle un pensamiento a mi esposa Laura. ¡Gracias por acompañarnos siempre!",
    sentAt: "2026-07-14T17:30:00",
    status: "leido_por_locutor",
    readAt: "2026-07-14T17:45:00",
  },
  {
    id: 8,
    radioName: "Radio Vida Nueva",
    radioImage: "https://readdy.ai/api/search-image?query=Christian%20worship%20radio%20station%20logo%20with%20cross%20and%20sunrise%20symbols%2C%20circular%20design%20soft%20blue%20and%20white%20colors%2C%20peaceful%20spiritual%20broadcast%20emblem%2C%20minimalist%20style&width=200&height=200&seq=lg-radio-vida&orientation=squarish",
    radioFrequency: "93.7 FM",
    content: "Hola equipo! Quería mandar un saludo muy especial a mi mamá que hoy está de cumpleaños. Ella me enseñó a amar la radio y siempre escuchamos juntas. ¡Los queremos!",
    sentAt: "2026-07-14T11:20:00",
    status: "al_aire",
    readAt: "2026-07-14T11:25:00",
    airedAt: "2026-07-14T11:35:00",
    locutorResponse: "¡Feliz cumpleaños a tu mamá, María Fernanda! Qué lindo regalo tener una hija que le dedica un saludo tan hermoso. ¡Bendiciones!",
    respondedAt: "2026-07-14T11:38:00",
  },
];

export const listenerSongRequests: ListenerSongRequest[] = [
  {
    id: 1,
    songName: "Vivir Mi Vida",
    artistName: "Marc Anthony",
    radioName: "La Mexicana FM",
    radioImage: "https://readdy.ai/api/search-image?query=Mexican%20regional%20radio%20station%20logo%20with%20guitar%20and%20sombrero%20elements%2C%20circular%20design%20warm%20orange%20and%20green%20colors&width=200&height=200&seq=ls-song-mexicana&orientation=squarish",
    radioFrequency: "98.7 FM",
    dedication: "Para todos los que están pasando por un mal momento, ¡la vida es una sola y hay que vivirla!",
    requestedAt: "2026-07-15T14:25:00",
    status: "pendiente",
  },
  {
    id: 2,
    songName: "Hawái",
    artistName: "Maluma",
    radioName: "La Kalle 99.9",
    radioImage: "https://readdy.ai/api/search-image?query=Pop%20music%20radio%20station%20logo%20with%20headphones%20and%20music%20equalizer%20bars%2C%20circular%20design%20vibrant%20pink%20and%20coral%20colors&width=200&height=200&seq=ls-song-kalle&orientation=squarish",
    radioFrequency: "99.9 FM",
    requestedAt: "2026-07-15T14:20:00",
    status: "pendiente",
  },
  {
    id: 3,
    songName: "Despacito",
    artistName: "Luis Fonsi ft. Daddy Yankee",
    radioName: "Radio Nueva Actitud",
    radioImage: "https://readdy.ai/api/search-image?query=Modern%20minimalist%20radio%20station%20logo%20design%20with%20musical%20notes%20and%20frequency%20waves%2C%20clean%20circular%20emblem%20style%2C%20warm%20golden%20palette&width=200&height=200&seq=ls-song-nueva&orientation=squarish",
    radioFrequency: "102.5 FM",
    dedication: "Dedicada a mi esposa Laura, 25 años juntos y contando. ¡Te amo!",
    requestedAt: "2026-07-15T14:15:00",
    status: "pendiente",
  },
  {
    id: 4,
    songName: "",
    artistName: "",
    radioName: "Rock Total Radio",
    radioImage: "https://readdy.ai/api/search-image?query=Rock%20radio%20station%20logo%20with%20electric%20guitar%20and%20lightning%20bolt%2C%20circular%20design%20black%20and%20red%20color%20scheme&width=200&height=200&seq=ls-song-rock&orientation=squarish",
    radioFrequency: "95.3 FM",
    greeting: "Buenas noches equipo de Rock Total. Solo quería mandarles un saludo y decirles que hacen que mis noches de estudio sean mucho más llevaderas. ¡Aguante el rock nacional!",
    requestedAt: "2026-07-15T14:10:00",
    status: "aceptada",
    acceptedAt: "2026-07-15T14:15:00",
  },
  {
    id: 5,
    songName: "A Puro Dolor",
    artistName: "Sin Bandera",
    radioName: "Radio Fe y Esperanza",
    radioImage: "https://readdy.ai/api/search-image?query=Christian%20radio%20station%20logo%20with%20dove%20symbol%2C%20circular%20minimalist%20design%2C%20soft%20warm%20colors%20white%20and%20golden%20tones&width=200&height=200&seq=ls-song-fe&orientation=squarish",
    radioFrequency: "88.1 FM",
    dedication: "Para todos los corazones rotos, ¡ánimo que siempre sale el sol!",
    requestedAt: "2026-07-15T13:05:00",
    status: "atendida",
    acceptedAt: "2026-07-15T13:10:00",
    attendedAt: "2026-07-15T13:18:00",
    operatorResponse: "Hermosa dedicatoria, gracias por compartir. Ahí va A Puro Dolor para todos.",
  },
  {
    id: 6,
    songName: "Bailando",
    artistName: "Enrique Iglesias",
    radioName: "Banda Radio MX",
    radioImage: "https://readdy.ai/api/search-image?query=Mexican%20banda%20music%20radio%20station%20logo%20with%20trumpet%20and%20accordion%2C%20circular%20design%20red%20white%20green%20colors&width=200&height=200&seq=ls-song-banda&orientation=squarish",
    radioFrequency: "107.9 FM",
    dedication: "10 años escuchándolos, esta canción me recuerda mis inicios. ¡Gracias por todo!",
    requestedAt: "2026-07-15T11:50:00",
    status: "reproducida",
    acceptedAt: "2026-07-15T11:55:00",
    attendedAt: "2026-07-15T12:00:00",
    playedAt: "2026-07-15T12:05:00",
  },
  {
    id: 7,
    songName: "Me Rehúso",
    artistName: "Danny Ocean",
    radioName: "Deportes Total Radio",
    radioImage: "https://readdy.ai/api/search-image?query=Sports%20radio%20station%20logo%20with%20soccer%20ball%20and%20trophy%20icon%2C%20circular%20design%20dark%20blue%20and%20gold%20color%20scheme&width=200&height=200&seq=ls-song-deportes&orientation=squarish",
    radioFrequency: "101.1 FM",
    requestedAt: "2026-07-15T11:30:00",
    status: "reproducida",
    acceptedAt: "2026-07-15T11:35:00",
    attendedAt: "2026-07-15T11:40:00",
    playedAt: "2026-07-15T11:42:00",
  },
  {
    id: 8,
    songName: "Tusa",
    artistName: "Karol G & Nicki Minaj",
    radioName: "La Kalle 99.9",
    radioImage: "https://readdy.ai/api/search-image?query=Pop%20music%20radio%20station%20logo%20with%20headphones%20and%20music%20equalizer%20bars%2C%20circular%20design%20vibrant%20pink%20and%20coral%20colors&width=200&height=200&seq=ls-song-kalle2&orientation=squarish",
    radioFrequency: "99.9 FM",
    requestedAt: "2026-07-15T10:15:00",
    status: "rechazada",
    rejectedAt: "2026-07-15T10:20:00",
    rejectionReason: "Contenido explícito — fuera de la política de la emisora en este horario.",
  },
  {
    id: 9,
    songName: "El Favor",
    artistName: "Paty Cantú",
    radioName: "Radio Vida Nueva",
    radioImage: "https://readdy.ai/api/search-image?query=Christian%20worship%20radio%20station%20logo%20with%20cross%20and%20sunrise%20symbols%2C%20circular%20design%20soft%20blue%20and%20white%20colors&width=200&height=200&seq=ls-song-vida&orientation=squarish",
    radioFrequency: "93.7 FM",
    dedication: "Para mi mejor amiga que está pasando por una ruptura. ¡Arriba amiga, tú puedes!",
    requestedAt: "2026-07-15T08:45:00",
    status: "aceptada",
    acceptedAt: "2026-07-15T08:50:00",
  },
  {
    id: 10,
    songName: "Robarte un Beso",
    artistName: "Carlos Vives & Sebastián Yatra",
    radioName: "La Mexicana FM",
    radioImage: "https://readdy.ai/api/search-image?query=Mexican%20regional%20radio%20station%20logo%20with%20guitar%20and%20sombrero%20elements%2C%20circular%20design%20warm%20orange%20and%20green%20colors&width=200&height=200&seq=ls-song-mexicana2&orientation=squarish",
    radioFrequency: "98.7 FM",
    requestedAt: "2026-07-14T18:30:00",
    status: "reproducida",
    acceptedAt: "2026-07-14T18:35:00",
    attendedAt: "2026-07-14T18:40:00",
    playedAt: "2026-07-14T18:42:00",
  },
  {
    id: 11,
    songName: "Vivir Mi Vida",
    artistName: "Marc Anthony",
    radioName: "Radio Nueva Actitud",
    radioImage: "https://readdy.ai/api/search-image?query=Modern%20minimalist%20radio%20station%20logo%20design%20with%20musical%20notes%20and%20frequency%20waves%2C%20clean%20circular%20emblem%20style&width=200&height=200&seq=ls-song-nueva2&orientation=squarish",
    radioFrequency: "102.5 FM",
    dedication: "Para mi abuelita que ya salió del hospital. ¡Bienvenida a casa abue!",
    requestedAt: "2026-07-14T15:50:00",
    status: "reproducida",
    acceptedAt: "2026-07-14T15:55:00",
    attendedAt: "2026-07-14T16:00:00",
    playedAt: "2026-07-14T16:05:00",
  },
  {
    id: 12,
    songName: "Despacito",
    artistName: "Luis Fonsi ft. Daddy Yankee",
    radioName: "Banda Radio MX",
    radioImage: "https://readdy.ai/api/search-image?query=Mexican%20banda%20music%20radio%20station%20logo%20with%20trumpet%20and%20accordion%2C%20circular%20design%20red%20white%20green%20colors&width=200&height=200&seq=ls-song-banda2&orientation=squarish",
    radioFrequency: "107.9 FM",
    requestedAt: "2026-07-14T12:45:00",
    status: "rechazada",
    rejectedAt: "2026-07-14T12:50:00",
    rejectionReason: "Solicitud duplicada — ya tenés una canción pendiente en la cola.",
  },
];

export const greetingStatusLabels: Record<GreetingStatus, string> = {
  enviado: "Enviado",
  leido_por_locutor: "Leído por Locutor",
  al_aire: "Al Aire",
  archivado: "Archivado",
};

export const greetingStatusColors: Record<GreetingStatus, { dot: string; text: string; bg: string }> = {
  enviado: { dot: "bg-primary-500", text: "text-primary-700", bg: "bg-primary-50 border-primary-200" },
  leido_por_locutor: { dot: "bg-sky-500", text: "text-sky-700", bg: "bg-sky-50 border-sky-200" },
  al_aire: { dot: "bg-rose-500 animate-pulse", text: "text-rose-700", bg: "bg-rose-50 border-rose-200" },
  archivado: { dot: "bg-foreground-400", text: "text-foreground-600", bg: "bg-foreground-50 border-foreground-200" },
};

export const songStatusLabels: Record<SongRequestStatus, string> = {
  pendiente: "Pendiente",
  aceptada: "Aceptada",
  atendida: "Atendida",
  reproducida: "Transmitida",
  rechazada: "Rechazada",
  cancelada: "Cancelada",
  expirada: "Expirada",
};

export const songStatusColors: Record<SongRequestStatus, { dot: string; text: string; bg: string; icon: string }> = {
  pendiente: { dot: "bg-amber-500", text: "text-amber-700", bg: "bg-amber-50 border-amber-200", icon: "ri-time-line" },
  aceptada: { dot: "bg-primary-500", text: "text-primary-700", bg: "bg-primary-50 border-primary-200", icon: "ri-check-line" },
  atendida: { dot: "bg-sky-500", text: "text-sky-700", bg: "bg-sky-50 border-sky-200", icon: "ri-broadcast-line" },
  reproducida: { dot: "bg-emerald-500", text: "text-emerald-700", bg: "bg-emerald-50 border-emerald-200", icon: "ri-check-double-fill" },
  rechazada: { dot: "bg-red-500", text: "text-red-700", bg: "bg-red-50/70 border-red-200", icon: "ri-close-circle-fill" },
  cancelada: { dot: "bg-foreground-400", text: "text-foreground-600", bg: "bg-foreground-50 border-foreground-200", icon: "ri-close-line" },
  expirada: { dot: "bg-foreground-300", text: "text-foreground-500", bg: "bg-foreground-50 border-foreground-200", icon: "ri-timer-line" },
};